import React, { type Dispatch, type ReactNode, type SetStateAction, useState } from 'react'

import type { GenericMessage } from 'commons/interfaces'

export const InterceptorsContext = React.createContext<UseInterceptorsInterface>(
  {} as UseInterceptorsInterface,
)

export interface ServerErrorModal {
  open: boolean
  title: string
}

export interface UseInterceptorsInterface {
  serverErrorModal: boolean
  setServerErrorModal: Dispatch<SetStateAction<boolean>>
  modalTitleErrorMessage: string
  setModalTitleErrorMessage: Dispatch<SetStateAction<string>>
  modalMessage: string
  setModalMessage: Dispatch<SetStateAction<string>>
  ErrorGenericMessage: GenericMessage
  timeoutTime: number
}

interface InterceptorsProviderProps {
  children: ReactNode
}

export const InterceptorsProvider: React.FC<InterceptorsProviderProps> = ({ children }) => {
  const ErrorGenericMessage: GenericMessage = {
    message: 'Tente novamente mais tarde.',
    title: 'Ocorreu um erro',
  }
  const timeoutTime = 1000
  const [serverErrorModal, setServerErrorModal] = useState<boolean>(false)

  const [modalTitleErrorMessage, setModalTitleErrorMessage] = useState<string>('...')
  const [modalMessage, setModalMessage] = useState<string>('...')

  return (
    <>
      <InterceptorsContext.Provider
        value={{
          ErrorGenericMessage,
          modalMessage,
          modalTitleErrorMessage,
          serverErrorModal,
          setModalMessage,
          setModalTitleErrorMessage,
          setServerErrorModal,
          timeoutTime,
        }}
      >
        {children}
      </InterceptorsContext.Provider>
    </>
  )
}
export const useInterceptors = () => React.useContext<UseInterceptorsInterface>(InterceptorsContext)
